<template>
  <div class="wrap">
    <div v-if="marketIsOnline">Coinmarketcap is online</div>
    <div v-else>Coinmarketcap is offline</div>
  </div>
</template>

<script>
  import { healthcheckMinInterval } from 'src/utils/config';

  export default {
    data() {
      return {
        marketIsOnline: false,
      };
    },
    computed: {
    },
    methods: {
      autoHealthcheck() {
        this.healthcheck();
        this.timerId = setTimeout(() => {
          this.autoHealthcheck();
        }, healthcheckMinInterval);
      },
      healthcheck() {
        this.$apiService.healthcheck({ dontShowErrors: true }).then(() => {
          this.marketIsOnline = true;
        }).catch(() => {
          this.marketIsOnline = false;
        });
      },
    },
    mounted() {
      this.autoHealthcheck();
    },
    beforeDestroy() {
      clearTimeout(this.timerId);
    },
  };
</script>

<style scoped>
  .wrap {
    width: 50%;
    margin: 10% auto;
    text-align: center;
    font-size: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/HealthCheck.vue